import React from 'react';
import { motion } from 'framer-motion';
import Footer from '../components/Footer';
import '../style.css';
import '../nov.css';

const Services = () => {
  const services = [
    {
      title: "DIGITAL DISTRIBUTION",
      description: "Get your music heard everywhere. We distribute to all major platforms.",
      gradient: "from-[#9BCFFF] to-[#FCD4FE]"
    },
    {
      title: "RIGHTS MANAGEMENT",
      description: "Protecting your music, your way. We ensure you get what you deserve.",
      gradient: "from-[#DBD0FD] via-[#FCD4FE] to-white"
    },
    {
      title: "ARTIST DEVELOPMENT",
      description: "Reach your full potential. We provide guidance and support every step of the way.",
      gradient: "from-black via-black/80 to-black"
    },
    {
      title: "MUSIC PUBLISHING",
      description: "Get your music placed in film, TV, and more. We'll connect you with the right opportunities.",
      gradient: "from-[#ffaa40] to-[#9c40ff]"
    },
    {
      title: "PLAYLIST PITCHING",
      description: "Get your music on popular playlists. We'll pitch your tracks to curators and influencers.",
      gradient: "from-[#a855f7] to-[#9BCFFF]"
    },
    {
      title: "SYNC LICENSING",
      description: "Sync your music to visual media. We'll help you get your songs featured in films, TV shows, and ads.",
      gradient: "from-[#3b82f6] to-[#DBD0FD]"
    }
  ];

  return (
    <>
    <section id="services" className="bg-[#f5f5f7] py-32 lg:py-48 relative overflow-hidden" style={{ fontFamily: 'aesthet-nova, Helvetica, Arial' }}>
      <div className="container mx-auto px-4 lg:px-0 relative z-10">
        
        {/* Header */}
        <div className="w-full text-center mb-16">
          <motion.div 
            className="mb-8 mt-4"
            initial={{ opacity: 0, y: -20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6 }}
          >
            <span 
              className="text-sm font-medium badge-gradient text-gray-700 py-3 px-6 rounded-full uppercase inline-block tracking-wide" 
              style={{ fontFamily: 'aesthet-nova' }}
            >
              OUR SERVICES
            </span>
          </motion.div>

          <motion.h2 
            className="text-3xl md:text-5xl lg:text-6xl font-bold mb-8 relative" 
            style={{ fontFamily: 'aesthet-nova', fontWeight: 700 }}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <div className="flex items-center justify-center gap-3">
              <motion.span 
                style={{ color: 'rgb(70, 52, 135)' }}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.3 }}
              >
                POWER YOUR
              </motion.span>
              <motion.span 
                style={{ '--shimmer-width': '250px' }} 
                className="animate-shimmer bg-clip-text bg-no-repeat [background-position:0_0] [background-size:var(--shimmer-width)_100%] [transition:background-position_1s_cubic-bezier(.6,.6,0,1)_infinite] bg-gradient-to-r from-black/70 via-black via-50% to-black/70"
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.4 }}
              >
                MUSIC CAREER
              </motion.span>
            </div>
          </motion.h2>

          <motion.p 
            className="px-4 md:text-xl font-light max-w-[577px] m-auto text-black leading-relaxed mb-12"
            style={{ fontFamily: 'system-ui, Avenir, Helvetica, Arial, sans-serif' }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: 0.5 }}
          >
            Media Nov provides comprehensive services to empower artists and labels worldwide.
          </motion.p>
        </div>

        {/* Service Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-screen-lg mx-auto">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="relative rounded-2xl overflow-hidden transition-all duration-300 group bg-white"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ delay: index * 0.1, duration: 0.5 }}
            >
              <div className="p-4 relative">
                <h4 className={`text-sm font-bold text-white absolute top-4 left-4 px-3 py-2 rounded-full bg-gradient-to-r ${service.gradient}`} style={{ fontFamily: 'PowerGrotesk, -system-ui, sans-serif' }}>
                  {service.title}
                </h4>
                <p className="text-gray-600 font-light text-sm mt-12 leading-relaxed" style={{ fontFamily: 'aesthet-nova' }}>
                  {service.description}
                </p>
              </div>
              <div className={`absolute bottom-0 left-0 w-full h-4 bg-gradient-to-r ${service.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>
            </motion.div>
          ))}
        </div>

      </div>
    </section>

    {/* Footer */}
    <Footer />
    </>
  );
};

export default Services;
